import LoginController from './login-view.controller';

require('./login-view.scss');

const LoginComponent = {
    selector: 'sbLogin',
    controller: LoginController,
    template: require('./login-view.html'),
};

export default LoginComponent;



// WEBPACK FOOTER //
// ./src/app/auth/login-view/index.js